import {api} from '../../constants/api';
import axios from 'axios';

export const getCustomerDetails = async (customerID) => {
  const data = {customerID};
  const result = await axios.post(api.GET_CUSTOMER_DETAILS, data);

  if (result.data.errorCode !== 0) throw new Error(`API error: ${result.data.errorCode}`);

  return result.data.body.customerData;
};